import { Injectable } from '@angular/core';
import {InAppBrowser} from "@ionic-native/in-app-browser";

/*
  Generated class for the UrlServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UrlServiceProvider {

  constructor(
    private iab: InAppBrowser
  ) {

  }

  openInSystemBrowser(url){
    const browser = this.iab.create(url, '_system');
  }

}



// WEBPACK FOOTER //
// ./src/providers/url-service/url-service.ts